/* eslint-disable import/no-cycle */
/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-restricted-globals */

'use-strict';

import angular, {
  ICompileService,
  IHttpResponse,
  IHttpService,
  ILocationService,
} from 'angular';
import { AutoboardNotification, RootScope } from '../../app.config';
import { ConfigService } from '../config/config.service';
import { SocketService } from '../connections/web-socket.service';
import { InterfaceService } from '../interface/interface.service';
import { UsersService } from '../users/users.service';
import { ServiceWorker } from './service-worker.service';
import { EConstantType } from '../../src/app/@shared-types/config/enums';

const PUSH_PERMISSION = 'pushNotificationsPermission_v2';
const PUSH_API_KEY = 'pushAPIInitialized';
const PUSH_API_SUBSCRIPTION = 'pushAPISubscription_v2';
const NOTIFICATIONS_API_KEY = 'notificationsAPIInitialized';

/* @ngInject */
export class NotificationService {
  private $rootScope: RootScope;

  private $http: IHttpService;

  private $compile: ICompileService;

  private $location: ILocationService;

  private configService: ConfigService;

  private interfaceService: InterfaceService;

  private socketService: SocketService;

  private serviceWorker: ServiceWorker;

  private usersService: UsersService;

  constructor(
    $rootScope: RootScope,
    $http: IHttpService,
    $compile: ICompileService,
    $location: ILocationService,
    configService: ConfigService,
    interfaceService: InterfaceService,
    socketService: SocketService,
    serviceWorker: ServiceWorker,
    usersService: UsersService,
  ) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$compile = $compile;
    this.$location = $location;
    this.configService = configService;
    this.interfaceService = interfaceService;
    this.socketService = socketService;
    this.serviceWorker = serviceWorker;
    this.usersService = usersService;
  }

  public init = (): void => {
    console.info('[Notification Service]: Initialize service.');
    this.getPreviousPushPermission();
  };

  /** Returns true, if current browser supports `Push API` */
  public browserSupportsPushAPI = (): boolean => {
    const pwaIsInstalled = window.matchMedia('(display-mode: standalone)').matches;
    if (!pwaIsInstalled) return false;

    if (('serviceWorker' in navigator) && ('PushManager' in window)) {
      console.info('[Notification Service]: Browser supports Push API.');
      return true;
    }
    return false;
  };

  /** Returns true, if current browser support `Notifications API` */
  public browserSupportsNotificationsAPI = (): boolean => {
    if ('Notification' in window) {
      console.info('[Notification Service]: Browser supports Notifications API.');
      return true;
    }
    return false;
  };

  /** Check if user previously gave permission to use push notifications.
   * If browser neither supports `Notifications API` and `Push API`, end process here.
   */
  private getPreviousPushPermission = (): void => {
    if (!this.browserSupportsNotificationsAPI()) {
      console.info('[Notification Service]: Browser does not support Notifications API. Cannot enable push notifications.');
      return;
    }

    // if (this.$rootScope.globals[PUSH_PERMISSION] === undefined) {
    //   console.info('[Notification Service]: Cannot get previous notifications permission, show onboarding screen.');
    //   this.interfaceService.showOnboardingScreen();
    // }

    if (this.$rootScope.globals[PUSH_PERMISSION]) {
      this.enableNotificationsAPI();
    }

    this.enableWebsocketNotifications();
  };

  public shouldShowOnboarding = (): boolean => {
    const noPreviousConcent = this.$rootScope.globals[PUSH_PERMISSION] === undefined;
    if (noPreviousConcent && this.browserSupportsPushAPI()) return true;
    return false;
  };

  /** Register current client to get notifications via
   * `WebSocket` connection to `Autoboard Server` */
  private enableWebsocketNotifications = (): void => {
    console.info('[Notification Service]: Enable WebSocket notifications.');

    this.socketService.emit('registerSocketNotification', {
      userId: this.$rootScope.globals.currentUser?.id || -1,
    });

    this.socketService.on('notification', () => {
      this.getLatestNotifications();
    });

    this.getLatestNotifications();
  };

  /** Enable browser's `Notifications API` to display notifications,
   * if app is open but running in the background. */
  private enableNotificationsAPI = () => {
    console.info('[Notification Service]: Trying to enable Notifications API');
    this.$rootScope.globals[NOTIFICATIONS_API_KEY] = false;
    if (!this.browserSupportsNotificationsAPI()) return;

    const { permission } = window.Notification;
    if (window.Notification.permission === 'granted') this.enablePush();
    if (permission === 'denied') return;

    window.Notification.requestPermission()
      .then((p) => {
        if (p === 'granted') {
          console.info('[Notification Service]: User gave browser permission to use Notifications API');
          this.$rootScope.globals[NOTIFICATIONS_API_KEY] = true;
          return this.enablePush();
        }
      })
      .catch((e) => {
        console.info('[Notification Service]: User declined Notifications API on browser level.');
        this.$rootScope.globals.notificationsAPI = false;
      });
  };

  private postPushSubscriptionToServer = async (
    pushSubscription: PushSubscription,
  ): Promise<IHttpResponse<void>> => this.$http.post<void>(`${API_URL}/api/notifications/push-subscription`, { pushSubscription });

  /** Enable browser's `Push API` to display notifications when app is not running.
   * Checks if a preivous `registration` was found, if not, registers a new one with
   * `Autoboard Server` */
  public enablePush = async (): Promise<void> => {
    console.info('[Notification Service]: Trying to enable Push API');
    this.$rootScope.globals[PUSH_API_KEY] = false;
    if (!this.browserSupportsPushAPI()) return;

    const serviceWorkerRegistration = await this.serviceWorker.getRegistration();
    if (!serviceWorkerRegistration) return;

    const pushKey = this.configService.get(EConstantType.NOTIFICATIONS_PUSH_KEY);

    const options = {
      userVisibleOnly: true,
      applicationServerKey: this.urlB64ToUint8Array(
        pushKey as string,
      ),
    };

    const existingSubscription = await serviceWorkerRegistration.pushManager.getSubscription();
    if (existingSubscription) {
      const keys = existingSubscription.toJSON().keys?.p256dh !== pushKey;
      if (!keys) await existingSubscription.unsubscribe();
    }

    const pushSubscription = await serviceWorkerRegistration.pushManager.subscribe(options);
    if (!pushSubscription) return;

    this.$rootScope.globals[PUSH_API_SUBSCRIPTION] = JSON.stringify(pushSubscription);
    this.$rootScope.globals[PUSH_API_KEY] = true;

    await this.postPushSubscriptionToServer(pushSubscription);
  };

  private deletePushSubscriptionToServer = async (
    pushSubscription: PushSubscription,
  ): Promise<IHttpResponse<void>> => this
    .$http.post(`${API_URL}/api/notifications/delete-push-subscription`, { pushSubscription });

  /** User accepts push notifications on onboarding screen. */
  public onboardingEnableNotifications = (): void => {
    console.info('[Notification Service]: User has accepted the use of push notifications from onboarding screen.');
    this.$rootScope.globals[PUSH_PERMISSION] = true;
    this.interfaceService.hideOnboadingScreen();
    this.enableNotificationsAPI();
  };

  /** User declines push notifications. */
  public onboardingDisableNotifications = async (): Promise<void> => {
    console.info('[Notification Service]: User has declined the use of push notifications from onboarding screen.');
    this.$rootScope.globals[PUSH_PERMISSION] = false;
    this.interfaceService.hideOnboadingScreen();

    this.$rootScope.globals[PUSH_API_KEY] = false;
    this.$rootScope.globals[NOTIFICATIONS_API_KEY] = false;

    if (this.$rootScope.globals[PUSH_API_SUBSCRIPTION]) {
      // eslint-disable-next-line max-len
      await this.deletePushSubscriptionToServer(JSON.parse(this.$rootScope.globals[PUSH_API_SUBSCRIPTION] as any) as PushSubscription);
      delete this.$rootScope.globals[PUSH_API_SUBSCRIPTION];
    }

    this.interfaceService.applyScope(this.$rootScope);
  };

  public getLatestNotifications = async (): Promise<void> => this
    .$http.get<AutoboardNotification[]>(`${API_URL}/api/notifications/notifications`)
    .then((res) => {
      this.$rootScope.notifications = res.data;
      this.$rootScope.notificationCount = res.data
        .filter((n: { read_status: boolean; }) => n.read_status === false).length;
      this.interfaceService.applyScope(this.$rootScope);

      if (this.$rootScope.notificationCount > 0) this.showNotificationToasts();
    })
    .catch((e: Error) => {
      console.error(`Error while trying to receive latest notifications: ${e}`);
    });

  private showNotificationToasts = (): void => {
    if (this.$rootScope.globals[NOTIFICATIONS_API_KEY] && !this.$rootScope.globals[PUSH_API_KEY]) {
      this.showBrowserNotification();
    }

    const latestNotification = this.$rootScope.notifications.filter((n) => !n.read_status)[0];
    this.$rootScope.notificationToasts = [latestNotification];
  };

  private removeNotificationToast = (toastId: number): void => {
    this.$rootScope.notificationToasts = this.$rootScope.notificationToasts
      .filter((t) => t.id !== toastId);
    this.markNotificationRead(toastId);
  };

  public clickNotification = (id: number): void => {
    const notification = this.$rootScope.notifications.filter((n) => n.id === id)[0];

    if (notification.link !== null) {
      this.$location.url(notification.link);
      this.removeNotificationToast(id);
      this.$rootScope.notificationExpand = false;
    }
  };

  public markNotificationRead = async (id: number): Promise<void> => {
    this.$rootScope.notificationCount -= 1;
    this.$rootScope.notifications.filter((n) => n.id === id)[0].read_status = true;
    await this.$http.post<void>(`${API_URL}/api/notifications/read-status/${id}`, {});
  };

  public markAllNotificationsRead = async (): Promise<void> => this
    .$http.post<void>(`${API_URL}/api/notifications/read-status`, {})
    .then(() => {
      this.$rootScope.notifications.forEach((n) => {
        n.read_status = true;
      });
      this.$rootScope.notificationCount = 0;
      this.interfaceService.applyScope(this.$rootScope);
    })
    .catch((e) => {
      console.error(e);
    });

  private showBrowserNotification = (): void => {
    if (!document.hasFocus() && Notification.permission === 'granted') {
      const notification = new Notification('Es warten neue Benachrichtigungen auf dich', {
        icon: '/img/notifications/logo-512.png',
      });
      // eslint-disable-next-line func-names
      notification.onclick = function () {
        parent.focus();
        window.focus();
        this.close();
      };
      setTimeout(notification.close.bind(notification), 5000);
    }
  };

  private urlB64ToUint8Array = (base64String: string): Uint8Array => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; i += 1) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };
}

export default angular.module('services.notification', [])
  .service('notificationService', NotificationService)
  .name;
